<script>
import BaseModal from 'dashboard/components/dahreply/BaseModal.vue';
import { useAlert } from 'dashboard/composables';
import StaffSelectionTable from '../../../../components/StaffSelectionTable.vue';

export default {
  name: "LinkBranchStaffModal",
  components: {
    BaseModal,
    StaffSelectionTable,
  },

  props: {
    staffs: {
      type: Array,
      default: () => [],
    },
    parentServiceId: {
      type: String,
      default: '',
    }
  },

  data() {
    return {
      isConfirming: false,
      isAllLoading: false,
      selectedStaffIds: this.staffs.map(s => s.id),
    }
  },

  computed: {
    branchId() {
      return this.$route.params.branchId;
    },
    serviceId() {
      return this.$route.params.serviceId || this.parentServiceId;
    },
  },

  methods: {
    async fetchStaff() {
      try {
        await this.$store.dispatch('branchStaff/fetchBranchStaff');
      } catch (err) {
        console.error(err);
        useAlert(`Failed to fetch staff list: ${err}`);
      }
    },

    handleSelectionChange(ids) {
      this.selectedStaffIds = ids;
    },

    async handleConfirm() {
      try {
        this.isConfirming = true;
        await this.$store.dispatch(
          'serviceStaff/bulkAssignStaffToService',
          {
            branch_id: this.branchId,
            service_id: this.serviceId,
            staff_ids: this.selectedStaffIds,
            update_mode: "replace"
          }
        );

        useAlert('Staff linked to service');
        this.$store.dispatch('onboarding/completeLocalTask', 'link_staff_to_service');
        if(this.$route.query.onboarding === 'true') {
          this.$router.push(this.$route.path);
        }
        this.$emit('refresh');
        this.$emit('close');
      } catch (err) {
        console.error(err);
        useAlert(`Failed to link staff to service: ${err}`);
      } finally {
        this.isConfirming = false;
      }
    },
  },

  async mounted() {
    this.isAllLoading = true;
    await this.fetchStaff();
    this.isAllLoading = false;
  }
};
</script>

<template>
  <BaseModal size="large" @close="$emit('close')">
    <template #title>
      Link Staffs
    </template>

    <!-- Integrated Table -->
    <StaffSelectionTable
      :branch-id="branchId"
      :initialSelectedIds="selectedStaffIds"
      @change="handleSelectionChange"
    />

    <template #footer>
      <div class="flex justify-end gap-3 mt-4">
        <woot-button color-scheme="secondary" @click="$emit('close')" :disabled="isAllLoading">
          Cancel
        </woot-button>
        <woot-button @click="handleConfirm" :disabled="isAllLoading" :is-loading="isConfirming">
          Link
        </woot-button>
      </div>
    </template>
  </BaseModal>
</template>